import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Herosection.css";
import Navbar from "../navbar/Navbar";
import HeroForm from "../heroForm/HeroForm";
import heroBg from "../Images/heroBg.png";

const Herosection = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
   const location = useLocation();
  useEffect(() => {
    const bg = new Image();
    bg.src = heroBg;
    bg.onload = () => {
      setIsImageLoaded(true);
    };
  }, []);
    const isArVrRoute = location.pathname === "/ar-vr-development";
  return (
    <div className={`herosection-container ${isImageLoaded ? 'main-bg-loaded' : ''}`} id="herosection" style={{marginTop: isArVrRoute ? '0' : ''}}>
      {/* <Navbar /> */}
      <section className="herosection arvrcontainer">
        <div className="herosection-left">
          <h1 className="hero-title">
            AR/VR Development <br />
& Technology That
Transforms Businesses
          </h1>
          <p className="hero-para">
            From Real-World Challenges to Virtual Solutions, We Help Brands Innovate Through AR/VR
          </p>
        </div>
        <div className="herosection-right">
          <HeroForm />
        </div>
      </section>
    </div>
  );
};

export default Herosection;
